export class Stats {

    constructor(
        public nbAlbums: number, 
        public nbImages: number, 
        public nbPjs: number,
        public nbWebcams: number,
        public nbObjects: number) {}

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/stats.ts